export const TOUR_HIGHLIGHT_TARGET_SELECTOR_COMPARE_PLANS =
  'tour-highlight__compare-plans'
